import RegionService from '~/services/region.service'

export default (ctx, inject) => {
  inject('region', new RegionService(ctx))
}
